import template   from './payment-sips.html'
import controller from './payment-sips.controller'
import './payment-sips.styl'

let component = {
  restrict: 'E',
  bindings: {
    productRef: '<',
    voucherInfos: '<',
    purchaseInfos: '<',
    validForm: '=',
    errorPurchase: '='
  },
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/payment-sips/payment-sips.component.js